import { Controller } from '@hotwired/stimulus';

import Commenter from '@/modules/commenter';
import Voting from '@/modules/voting';

export default class extends Controller {
  connect() {
    new Commenter().create();
    new Voting({ voteableType: 'Comment', wrapper: '.comment__card' }).create();
  }
}
